export default {
    label_task:{
        en:"Configurations",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Configurations",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Configuration",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Configurations",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_purpose:{
        en:"Purpose",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_config_value:{
        en:"Value",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_description:{
        en:"Description",
        bn:'ব্যবহারকারীর বিবরণ'
    }
}